export default __webpack_public_path__ + "static/media/64_desktop.54e06a3c.jpg";